export const clientInactive = 'Inactive';
export const clientActive = 'Active';
export const newContractLabel = 'New Contract';
export const billingModelSelectLabel = 'Select Billing Model';
